import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
// Material UI Components
import { Alert } from "@material-ui/lab";
import { Button, Grid, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Local
import { useDispatch } from "react-redux";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { SET_NAVBAR_TITLE } from "action_creators/actioncreator";
import CustomTable from "../components/Table";
import LoaderHoc from "../../../components/HOC/LoaderHoc";
import { SDCloudBackendAPIWithToken } from "../../../apis/backendAPI";
import TrainingDetails from "./TrainingDetails";
import { IconButton } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import { SHOW_NOTIFICATION } from "action_creators/actioncreator";
import moment from "moment";
import ShimmerUserTable from "../components/ShimmerUserTable";
// Styling
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "24px",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    marginTop: "10px",
    flexWrap: "wrap",
    gap: "16px",
  },
  titleSection: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  backButton: {
    borderColor: "#00AEEF !important",
    color: "#00AEEF !important",
    fontFamily: `${theme.palette.fontList?.selectedFont || "Roboto"} !important`,
    fontWeight: "600 !important",
    textTransform: "none !important",
    borderRadius: "2px !important",
    padding: "6px 16px !important",
    backgroundColor: "#fff !important",
    "&:hover": {
      backgroundColor: "rgba(0, 174, 239, 0.08) !important",
      borderColor: "#00AEEF !important",
    },
  },
  cardContainer: {
    padding: "24px !important",
    borderRadius: "0px !important",
    boxShadow: "none !important",
    border: "1px solid #E0E0E0 !important",
    backgroundColor: "#ffffff !important",
  },
}));

const ViewTraining = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [rows, setrows] = useState([]);
  const [currentScreen, setCurrentScreen] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [currentTraining, setCurrentTraining] = useState("");
  const [currentRef, setCurrentRef] = useState("");
  const [trainingDescription, setTrainingDescription] = useState("");
  const [recordCount, setrecordCount] = useState(10);
  const [searchValue, setsearchvalue] = useState("");
  const [pageNo, setpageNo] = useState(1);
  const [rowstemp, setrowstemp] = useState([]); 
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState([]);
  const [notificationType, setNotificationType] = useState("");
  const profileData = JSON.parse(localStorage.getItem("profileData"));
  const account = profileData.account;
  let domain = JSON.parse(localStorage.getItem("internal_domains"))?.domains;
  let userEmail = profileData.email;
  let hasDomain = domain?.some((res) => userEmail.includes(res));
  const [isInternal] = useState(hasDomain);
  useEffect(() => {
    dispatch(SET_NAVBAR_TITLE(isInternal ? account + "  - Instructor Access" : "Instructor Access"));
    renderrow(pageNo,recordCount,searchValue);
  }, [dispatch, isInternal, account, pageNo,recordCount,searchValue]);
  // States
  const columns = [
    {
      Header: "Name",
      accessor: "training_name",
    },
    {
      Header: "Prefix",
      accessor: "training_prefix",
    },
    {
      Header: "Start Time",
      accessor: "start_time",
    },
    {
      Header: "End Time",
      accessor: "end_time",
    },
    {
      Header: "Time Zone",
      accessor: "time_zone",
    },
    {
      Header: "Training ID",
      accessor: "deal_id",
    },
    {
      Header: "Created On",
      accessor: "created_on",
    },
    {
      Header: "Users",
      accessor: "users",
    },
  ];

  let data = [];
  const renderrow = async (page_no,record_count,search_value) => {
    return SDCloudBackendAPIWithToken()
      .get(
        `/instructer/view_trainings?search=${search_value ??
          searchValue}&page_no=${
          page_no ? page_no : pageNo
        }&record_count=${record_count? record_count:recordCount}`
      )
      .then((resp) => resp.data)
      .then((resp) => {
        resp.trainings.forEach((item) => {
          data.push({
            training_name: item.training_name,
            training_prefix: item.training_prefix,
            start_time: item.training_start_date,
            end_time: item.training_end_date,
            time_zone: item.time_zone,
            deal_id: item.deal_id,
            description: item.description,
            created_on: item.created_on,
            users: (
              <IconButton onClick={() => handleViewButton(item.training_name, item.reference_id, item.description)}>
                <Visibility />
              </IconButton>
            ),
          });
        });
        setrows(data);
        setIsLoading(false);
        setrowstemp(resp);
      })
      .catch((err) => {
        let message = err.response.data.message || "unknown error occured";
        setIsLoading(false);
      });
  };

  const handleDeleteButton = (selectedRowIds, selectedFlatRows) => {
    let payload = {};
    selectedFlatRows.forEach((item) => {
      let training_name = item.original.training_name;
      payload["training_name"] = training_name;
      let reference_id = item.original.deal_id.split("-")[1];
      payload["reference_id"] = reference_id;
      SDCloudBackendAPIWithToken()
        .post(`/instructer/delete_trainings`,payload)
        .then((resp) => resp.data)
        .then((data) => {
          const payload = {
            message: "Training(s) Deleted Successfully.",
            color: "success",
          };
          dispatch(SHOW_NOTIFICATION({ payload }));
         renderrow(pageNo,recordCount,searchValue);
        })
        .catch((err) => {
          const payload = {
            message: err?.response?.data?.message || "Unable to delete training",
            color: "danger",
            error: err
          };
          payload.message && dispatch(SHOW_NOTIFICATION({ payload }));   
        });
    });
  };
  const handleViewButton = (training_name, reference_id, description) => {
    setCurrentScreen("Training Details");
    setCurrentTraining(training_name);
    setCurrentRef(reference_id);
    setTrainingDescription(description);
  };

  const renderNotififications = () => {
    let notifications = notificationMessage.map((item) => {
      let notificationType = item.success ? "success" : "error";
      return (
        <Alert
          onClose={() => setShowNotification(false)}
          severity={notificationType}
          spacing={1}
        >
          {item.message}
        </Alert>
      );
    });

    return notifications;
  };

  const handleAddTrainingButton = () => {
    history.push("/Instructer/addtraining");  
  };
  const handleDataSearch = (search_value) => {
    setsearchvalue(search_value);
  };
  const handlePagination = (page_no,record_count) => {
    setrecordCount(record_count)
    setpageNo(page_no);
  };
  if (currentScreen === "Training Details") {
    return (
      <div className={classes.root}>
        <div className={classes.headerContainer}>
          <div className={classes.titleSection}>
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={() => setCurrentScreen(null)}
              variant="outlined"
              className={classes.backButton}
            >
              Back
            </Button>
            <Typography variant="h4" style={{ color: "#333", fontWeight: 600 }}>
              {currentTraining}
            </Typography>
          </div>
        </div>
        <TrainingDetails
          training_name={currentTraining}
          reference_id={currentRef}
          description={trainingDescription}
        />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.headerContainer}>
        <div className={classes.titleSection}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => history.push("/settings")}
            variant="outlined"
            className={classes.backButton}
          >
            Back
          </Button>
          <Typography variant="h4" style={{ color: "#333", fontWeight: 600, marginLeft: 8 }}>
            Instructor Access
          </Typography>
        </div>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {showNotification ? renderNotififications() : null}
        </Grid>
        <Grid item xs={12}>
          {isLoading ? (
            <ShimmerUserTable />
          ) : (
            <Paper className={classes.cardContainer} elevation={0}>
              <CustomTable
                columns={columns}
                data={rows}
                handleDeleteButtonClick={handleDeleteButton}
                handleButtonClick={handleAddTrainingButton}
                handleViewButtonClick={handleViewButton}
                tableTitle="Trainings Overview"
                buttonTitle="Add New Training"
                hiddenColumns={[]}
                count={rowstemp?.pagination?.total_pages}
                page={rowstemp?.pagination?.current_page}
                setList={handlePagination}
                handleSearch={handleDataSearch}
              />
            </Paper>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default ViewTraining;
